import { render, staticRenderFns } from "./Contact-form.vue?vue&type=template&id=44ab6fec&"
import script from "./Contact-form.vue?vue&type=script&lang=js&"
export * from "./Contact-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports